/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import {
    ConsoleTransport,
    ISageTransportParams,
    ITransport,
    SageTransport,
} from '@tivocorp/tivo-webapp-loggers';

import {
    DEFAULT_SAGE_ENDPOINT,
    MEDIA_HEALTH_EVENTS_INTERVAL,
    SAGE_LOGGING_VERSION,
} from '../../config';

export class SageLogger {
    private mSageParams: ISageTransportParams = {
        appName: 0xc, // Kaveri - Application on SmartTVs (other than Oyster)
        developmentPhase: 0x1, // Development - Debug builds
        device: 0x6, // SmartTV
        deviceFamily: 0x6, // SmartTV
        hecEndpoint: '',
        loggingVersion: SAGE_LOGGING_VERSION,
        mediaHealthEventsInterval: MEDIA_HEALTH_EVENTS_INTERVAL,
        os: 0x5,
        partnerId: 1111, // It is a TIVO test development.
        tokenSalt: '',
    };

    private mDiagnosticsTransport: ITransport;

    private mOperationsTransport: ITransport;

    private static mSageLogger: SageLogger;

    private constructor() {
        this.mDiagnosticsTransport = new ConsoleTransport();
        this.mOperationsTransport = new ConsoleTransport();
        this.mSageParams.hecEndpoint = DEFAULT_SAGE_ENDPOINT;
    }

    private initDiagnosticsTransport() {
        const tokenSalt = 'Sage1D:';
        this.mDiagnosticsTransport = new SageTransport({ ...this.mSageParams, tokenSalt });
    }

    private initOperationsTransport() {
        const tokenSalt = 'Sage1O:';
        this.mOperationsTransport = new SageTransport({ ...this.mSageParams, tokenSalt });
    }

    public configure(config: { environment?: string; partnerId?: string }) {
        if (config.environment) {
            this.mSageParams.developmentPhase = config.environment === 'production' ? 0x3 : 0x1; // Development - Debug builds
        }
        if (config.partnerId) {
            this.mSageParams.partnerId = Number(config.partnerId.split('.')[1]);
        }

        this.initDiagnosticsTransport();
        this.initOperationsTransport();
    }

    public getDiagnosticsTransport(): ITransport {
        return this.mDiagnosticsTransport;
    }

    public getOperationsTransport(): ITransport {
        return this.mOperationsTransport;
    }

    public static getInstance(): SageLogger {
        if (!SageLogger.mSageLogger) {
            SageLogger.mSageLogger = new SageLogger();
        }
        return SageLogger.mSageLogger;
    }
}
